// extracted by mini-css-extract-plugin
export default {"btn":"Forms_btn__uBGCN","btnRow":"Forms_btnRow__Me0zL","emailForm":"Forms_emailForm__QIhsg","notEmail":"Forms_notEmail__1K8wu"};